<template>
	<div :class="{ 'benefits--desktop': isDesktop }">
		<ul class="benefit-items">
			<li v-for="(item, i) in labels.benefitItems" :key="`item-${i}`" class="u-flex-v-center">
				<SvgIcon v-if="item.iconName" :icon-name="item.iconName" class="benefit-icon flex-icon mr-3" />
				<div>
					<b class="u-font-weight-semibold">{{ item.title }}</b>
					<br />
					{{ item.description }}
				</div>
			</li>
		</ul>
	</div>
</template>

<script>
import SvgIcon from "@SharedVueComponents/SvgIcon/SvgIcon";

export default {
	components: { SvgIcon },
	props: {
		labels: { type: Object, required: true },
		isDesktop: Boolean,
	},
};
</script>

<style lang="scss" scoped>
.benefits--desktop {
	position: absolute;
	bottom: 40px;
	width: 100%;
	display: flex;
	justify-content: center;
}

.benefit-items {
	margin: unset;
	padding: unset;
	list-style: none;
	display: grid;
	gap: 30px;

	.benefits--desktop & {
		padding: 30px 36px;
		border: 24px solid rgba(255, 255, 255, 0.5);
		background: var(--color-white);
		background-clip: padding-box;
		max-width: calc(100% - #{$space-xl});
	}
}

.benefit-icon {
	font-size: $space-l;
}
</style>
